import { Component, EventEmitter, OnInit, Output, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { RubroService } from 'src/app/services/rubro.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { SecurityService } from 'src/app/shared/services/security.service';

@Component({
  selector: 'app-rubro-modal-add-edit',
  templateUrl: './modal-add-edit.component.html',
  styleUrls: ['./modal-add-edit.component.scss'],
  providers: [SecurityService],
})
export class RubroModalAddEditComponent implements OnInit {

  // Modales
  @ViewChild('agregarRubro', { static: true }) modalAddEditRubro: ModalDirective;

  @Output() onAddEdit: EventEmitter<any> = new EventEmitter()

  // Form
  formData: FormGroup

  // Data &  Tmp
  isEditing: boolean = false
  codigoEditado = 0
  private rutEmpresa: number

  // Utils

  constructor(
    private clog: ConsoleService,
    private rubroService: RubroService,
    private fb: FormBuilder,
    private formValidatorsService: FormValidatorsService,
    private messageRendererService: MessageRendererService,
    private toastrService: ToastService,
    private accesolocalstorage: SecurityService,
  ) {}

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa())
    this.createForm()
  }

  private createForm() {
    this.formData = this.fb.group({
      activo: [true, [Validators.required]],
      descripcion: [null, [Validators.required, Validators.maxLength(100), Validators.minLength(5)]],
    });
  }

  show() {
    this.isEditing = false
    this.clearData()
    this.modalAddEditRubro.show()
  }

  hide() {
    this.modalAddEditRubro.hide()
  }

  load(rubro) {
    this.isEditing = true
    this.codigoEditado = rubro.codigo
    this.clearData()
    this.formData.get('activo').setValue(rubro.activo)
    this.formData.get('descripcion').setValue(rubro.descripcion)
    this.modalAddEditRubro.show()
  }

  clearData() {
    this.formValidatorsService.reset(this.formData)
    this.formData.get('activo').setValue(true)
  }

  addEdit() {
    this.formValidatorsService.validateAllFormFields(this.formData)
    if (!this.formData.valid)
      return

    const inputParams: any = {
      entidad: {
        activo: this.formData.get('activo').value,
        descripcion: this.formData.get('descripcion').value,
        empresa_rut: this.rutEmpresa,
      }
    }
    if (this.isEditing)
      inputParams.entidad.codigo = this.codigoEditado

    this.rubroService.guardar(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      this.toastrService.success('Operación realizada con éxito')
      this.onAddEdit.emit(respuesta)
      this.hide()
    })
  }

}

